module.exports = __webpack_public_path__ + "img/game_kungfu.cf534b65.png";